import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { AppBar, Box, Button, Icon, IconButton, Menu, MenuItem, Typography } from '@popmenu/common-ui';
import { Menu as MenuIcon } from '@popmenu/web-icons';
import { classNames, makeStyles } from '../../../utils/withStyles';
import { screenReaderOnly } from '../../../assets/jss/utils/screenReaderOnly';
import PopmenuLogoSVG from '../../../assets/svg/popmenu_logo_2020.svg';

const useStyles = makeStyles(theme => ({
  appBar: {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
    backgroundColor: theme.palette.surface.light,
    borderBottom: `1px solid ${theme.palette.gray.main}`,
    padding: theme.spacing(2, 4),
  },
  inner: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
    maxWidth: '1200px',
  },
  logo: {
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(3),
      top: '5px',
    },
    height: theme.spacing(5),
    position: 'relative',
    top: theme.spacing(1),
  },
  logoText: {
    ...screenReaderOnly,
  },
  menuButton: {
    fontSize: '1rem',
    padding: theme.spacing(1),
  },
  menuButtonContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
    display: 'none',
  },
  navLink: {
    '&.active': {
      color: theme.palette.red.main,
    },
  },
  navLinksContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export const Nav = () => {
  const classes = useStyles();
  const dishFeedActive = useRouteMatch('/places');

  const [navAnchorEl, setNavAnchorEl] = useState<HTMLButtonElement | null>(null);
  const onNavButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setNavAnchorEl(e.currentTarget);
  };
  const onNavClose = () => {
    setNavAnchorEl(null);
  };

  return (
    <React.Fragment>
      <AppBar
        className={classes.appBar}
        color="secondary"
        component="nav"
        position="sticky"
      >
        <Box>
          <Box className={classes.inner}>
            <NavLink to="/">
              <Typography component="span">
                <PopmenuLogoSVG aria-hidden className={classes.logo} />
                <span className={classes.logoText}>
                  <FormattedMessage id="nav.title" defaultMessage="Popmenu" />
                </span>
              </Typography>
            </NavLink>
            <Box className={classes.navLinksContainer}>
              <Button
                className={classNames(
                  classes.navLink,
                  dishFeedActive ? 'active' : null,
                )}
                component={NavLink}
                exact
                role="link"
                to="/"
                variant="text"
              >
                <FormattedMessage id="nav.dish_feed" defaultMessage="Dish Feed" />
              </Button>
            </Box>
            <Box className={classes.menuButtonContainer}>
              <IconButton
                aria-controls="nav-menu"
                aria-haspopup="true"
                aria-label="Open navigation menu"
                className={classes.menuButton}
                onClick={onNavButtonClick}
              >
                <Icon icon={MenuIcon} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </AppBar>
      <Menu
        anchorEl={navAnchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        id="nav-menu"
        keepMounted
        onClose={onNavClose}
        open={Boolean(navAnchorEl)}
      >
        <MenuItem
          className={classNames(
            classes.navLink,
            dishFeedActive ? 'active' : null,
          )}
          // @ts-expect-error No overload matches this call.
          component={NavLink}
          exact
          onClick={onNavClose}
          role="link"
          to="/"
          variant="text"
        >
          <FormattedMessage id="nav.dish_feed" defaultMessage="Dish Feed" />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};
